import { Component, OnInit } from '@angular/core';
import { HomeService } from '../../services/home.service';

@Component({
  selector: 'app-dailyquotes',
  templateUrl: './dailyquotes.component.html',
  styleUrls: ['./dailyquotes.component.scss']
})
export class DailyquotesComponent implements OnInit {
  quotesObj:any={background:'',quote:''};
  constructor(private homeService: HomeService) { }

  ngOnInit() {
    this.quotes();
  }


  quotes() {
    this.homeService.getQuotes().subscribe(res=> {
      this.quotesObj = res;
    }); 
  }

}



// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/dailyquotes/dailyquotes.component.ts